module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Seventy-Thousand-Dollar Outhouse")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('strong', [_vm._v("About the Author")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_c('strong', [_vm._v("Dedication")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_c('strong', [_vm._v("Copyright Information ©")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgments"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_c('strong', [_vm._v("Foreword: ")]), _vm._v(" Paddling: An Activity for All Ages")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#paddling-an-activity-for-all-ages"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#introduction"
    }
  }, [_c('strong', [_vm._v("Introduction: ")]), _vm._v("Why I Like Extended Multi-Day Paddling Trips")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#why-i-like-extended-multi-day-paddling-trips"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-one-boats-in-my-blood"
    }
  }, [_c('strong', [_vm._v("Chapter One: Boats in My Blood")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#boats-in-my-blood-a-personal-history"
    }
  }, [_vm._v("Boats in My Blood: A Personal History")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#getting-down-to-business"
    }
  }, [_vm._v("Getting Down to Business")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#sailing-sailing"
    }
  }, [_vm._v("Sailing, Sailing…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#up-close-and-personal"
    }
  }, [_vm._v("Up Close and Personal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#if-once-you-have-slept-on-an-island"
    }
  }, [_vm._v("If Once You Have Slept on an Island")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-two-georgian-bay-odyssey"
    }
  }, [_c('strong', [_vm._v("Chapter Two: Georgian Bay Odyssey")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#georgian-bayjuly-2004"
    }
  }, [_vm._v("Georgian Bay—July 2004")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#getting-started"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#five-hours-on-the-road"
    }
  }, [_vm._v("Five Hours on the Road")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#cairn-island"
    }
  }, [_vm._v("Cairn Island")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#picking-strawberries-again"
    }
  }, [_vm._v("Picking Strawberries Again")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-rattlesnake-dance-and-a-personal-failure"
    }
  }, [_vm._v("The Rattlesnake Dance and a Personal Failure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#hurry-up-and-go"
    }
  }, [_vm._v("Hurry Up and Go!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#paddling-in-the-rain"
    }
  }, [_vm._v("Paddling in the Rain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#bugs"
    }
  }, [_vm._v("Bugs!")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-three-four-days-in-the-jungle",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Three: Four Days in the Jungle")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#prologue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-adventure-begins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Adventure Begins")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#in-the-jungle-the-lion-sleeps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Jungle, the Lion Sleeps…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#white-paws",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Paws")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#saying-goodbye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saying Goodbye")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-four-lulu-key-lullaby",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Four: Lulu Key Lullaby")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#everglades-city-february-2013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everglades City, February 2013")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#getting-started-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-grand-tour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grand Tour")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#finally-fakahatchee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finally, Fakahatchee")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#return-to-everglades-city",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Everglades City")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-five-the-seventy-thousand-dollar-outhouse",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Five: The Seventy-Thousand-Dollar Outhouse")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#misty-isles-august-2008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Misty Isles, August 2008")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#sugar-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Island")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#grenadier-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grenadier Island")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#staying-put",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staying Put!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-70000-outhouse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The $70,000 Outhouse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-bridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bridge")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-six-return-to-the-saguenay-fjord",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Six: Return to the Saguenay Fjord")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#return-to-the-saguenay-fjord-july-2013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to the Saguenay Fjord, July 2013")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#oh-what-a-feelingcheck-that-engine-light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh, What a Feeling—Check That Engine Light")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-long-and-winding-road",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Long and Winding Road")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#deflated",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deflated")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#detour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detour")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-dues-we-pay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dues We Pay")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#belugas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belugas!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-granite-gps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Granite GPS")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-seven-deja-vus-on-the-ochlockonee-river",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Seven: Deja Vus on the Ochlockonee River")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#prologue-march-2014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue, March 2014")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#a-trailer-park-nestled-in-a-swamp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Trailer Park Nestled in a Swamp")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#deja-vus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deja Vus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#flood-stage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flood Stage")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#drying-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drying Out")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#paddling-through-the-woods",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paddling Through the Woods")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#a-side-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Side Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#what-a-difference-a-year-makes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What a Difference a Year Makes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#last-year-revisited",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Year Revisited")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#this-year",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Year")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-eight-on-the-bartram-history-trail",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Eight: On the Bartram History Trail")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#palatka",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palatka")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#on-the-big-lake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Big Lake")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-bartram-history-trail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bartram History Trail")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-best-day-of-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Best Day of the Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#back-to-palatka",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back to Palatka")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-nine-loreto-to-la-paz-by-kayak",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Nine: Loreto to La Paz by Kayak")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#part-i-the-gift-february-2-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I: The Gift, February 2, 2018")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#you-cant-get-there-from-here",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Can’t Get There from Here")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#every-adventure-begins-with-a-first-step",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Every Adventure Begins with a First Step")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-endless-bus-ride",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Endless Bus Ride")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#finally-loreto",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finally, Loreto")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#on-the-malecon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Malecon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-old-capital-city",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Capital City")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#a-first-meeting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A First Meeting")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#somewhere-between-shy-and-anti-social",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Somewhere Between Shy and Anti-Social")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#should-it-stay-or-should-it-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Should It Stay, or Should It Go?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#part-ii-along-the-baja-peninsula-the-adventure-begins.-were-all-going-to-die",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Along the Baja Peninsula, the Adventure Begins. We’re All Going to Die!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#disappointment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disappointment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#finally-on-the-water",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finally, On the Water")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#taking-care-of-business",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Care of Business")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#whats-for-dinner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s for Dinner?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#breaking-camp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking Camp")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#i-get-to-paddle-the-single",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Get to Paddle the Single")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#finally-out-of-the-wind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finally, Out of the Wind")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-joys-of-a-layover-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Joys of a Layover Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#our-first-hike",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our First Hike")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-2",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-3",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#siesta",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siesta")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#getting-wet-staying-clean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Wet, Staying Clean")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-4",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-6",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#will-this-wind-ever-stop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will This Wind Ever Stop?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#ramons-catastrophe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramon’s Catastrophe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#publication-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Publication Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#our-longest-paddling-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Longest Paddling Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-mission-and-the-ranch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mission and the Ranch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#san-evaristito",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("San Evaristito")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#nazanin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nazanin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#taco-soup-and-a-full-moon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taco Soup and a Full Moon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#a-lazy-layover-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lazy Layover Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#san-evaristo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("San Evaristo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#lupe-sierras-and-maggi-maes-restaurant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lupe Sierra’s and Maggi Mae’s Restaurant")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-legend-of-el-mechudo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legend of El Mechudo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#we-meet-el-mechudo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Meet El Mechudo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#into-the-water",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Water")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#el-portugues-and-trips-end",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Portugues and Trip’s End")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#goodbye-and-going-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goodbye and Going Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#part-iii-epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Epilogue")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0